import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { constants } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'
import Product from 'components/product/Product/Product'
import Carousel from 'components/ui/Carousel/Carousel'
import CommonButton from 'components/buttons/CommonButton/CommonButton'
import ContentLoaderAwareOfRequestLoader from 'components/loaders/ContentLoaderAwareOfRequestLoader/ContentLoaderAwareOfRequestLoader'

import messages from './messages'
import s from './EmptyQueueRecommendationsModal.scss'


const options = {
  dots: true,
  arrows: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [{
    breakpoint: constants.media.desktopStart,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  }, {
    breakpoint: constants.media.tabletLandscapeStart,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
  }],
}


class EmptyQueueRecommendationsModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    gender: PropTypes.string,
    products: PropTypes.array,
    isFetching: PropTypes.bool,
  }

  static defaultProps = {
    name: constants.modals.EmptyQueueRecommendations,
  }

  componentDidMount() {
    const { gender } = this.props

    actions.view.emptyQueueRecommendationModal.fetch({ gender, limit: 15, randomLimit: 15 })
  }

  componentWillReceiveProps({ pathname }) {
    const { pathname: oldPathname } = this.props

    if (pathname !== oldPathname) {
      this.close()
    }
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, products, isFetching } = this.props

    const metadata          = { placement: 'empty queue click' }
    const snowplowMetadata  = { placement: 'empty queue recommendations modal' }

    return (
      <Modal
        className={s.modal}
        name={name}
        title={messages.title}
        titleUppercase
        onClose={this.close}
      >
        {
          isFetching ? (
            <ContentLoaderAwareOfRequestLoader className={s.loader} />
          ) : (
            <Media mobile>
              {
                (isMobile) => (
                  <Fragment>
                    {
                      React.createElement(
                        isMobile ? 'div' : Carousel,
                        isMobile ? { className: s.products } : { options },
                        products.map((product) => (
                          <Product
                            key={product.id}
                            containerClassName={s.product}
                            data={product}
                            addTo="queue"
                            isQuickViewVisible
                            metadata={metadata}
                            snowplowMetadata={snowplowMetadata}
                            onQuickViewClick={this.close}
                          />
                        ))
                      )
                    }
                    {
                      isMobile && (
                        <CommonButton
                          className={s.button}
                          back
                          fullWidth
                          whiteWithBorder
                          onClick={this.close}
                        />
                      )
                    }
                  </Fragment>
                )
              }
            </Media>
          )
        }
      </Modal>
    )
  }
}


export default connect({
  gender: 'models.me.gender',
  products: 'view.emptyQueueRecommendationModal.products',
  isFetching: 'view.emptyQueueRecommendationModal.isFetching',
  pathname: 'routing.location.pathname',
})(EmptyQueueRecommendationsModal)
